import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  dealerRequest: ['id'],
  dealerAddRequest: ['data'],
  dealerUpdateRequest: ['data'],
  dealerDeleteRequest: ['id'],
  dealerSuccess:['data'],
  dealerFailure:['error'],
});

export const DealerTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({fetching: false, error: null, data});

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DEALER_REQUEST]: request,
  [Types.DEALER_ADD_REQUEST]: request,
  [Types.DEALER_UPDATE_REQUEST]: request,
  [Types.DEALER_DELETE_REQUEST]: request,
  [Types.DEALER_SUCCESS]: success,
  [Types.DEALER_FAILURE]: failure,
});